const SearchBarToggleVisibilityEventName = 'searchBarToggleVisibility';
const SearchBarFindUserEventName = 'searchBarFindUser';

export { SearchBarToggleVisibilityEventName, SearchBarFindUserEventName };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/home/_components/search-bar/_domain/models/events.ts